import { Button, Input, Modal, Radio, Typography } from 'antd';
import React from 'react';

import { RejectionModalState } from './types';

const { Text } = Typography;
const { TextArea } = Input;

interface RejectionModalProps {
  rejectionModal: RejectionModalState;
  setRejectionModal: (modal: RejectionModalState) => void;
  onReject: () => void;
  loading: boolean;
}

export const RejectionModal: React.FC<RejectionModalProps> = ({
  rejectionModal,
  setRejectionModal,
  onReject,
  loading,
}) => {
  const handleCancel = () => {
    setRejectionModal({ visible: false, requestId: '', reason: '', customMessage: '' });
  };

  const isDisabled =
    !rejectionModal.reason || (rejectionModal.reason === 'custom' && !rejectionModal.customMessage.trim());

  return (
    <Modal
      title="Odrzuć weryfikację mObywatel"
      open={rejectionModal.visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Anuluj
        </Button>,
        <Button key="confirm" type="primary" danger loading={loading} disabled={isDisabled} onClick={onReject}>
          Odrzuć weryfikację
        </Button>,
      ]}>
      <div className="space-y-4">
        <div>
          <Text strong className="block mb-2">
            Wybierz powód odrzucenia:
          </Text>
          <Radio.Group
            value={rejectionModal.reason}
            onChange={(e) => setRejectionModal({ ...rejectionModal, reason: e.target.value })}
            className="w-full">
            <div className="space-y-3">
              <Radio value="incorrect_data" className="!flex !items-start">
                <div className="ml-2">
                  <div className="font-medium">Nieprawidłowe dane</div>
                  <div className="text-xs text-gray-500 mt-1">
                    Użytkownikowi zostanie wysłany komunikat o konieczności poprawienia danych w zakładce
                    &quot;Informacje o koncie&quot;
                  </div>
                </div>
              </Radio>
              <Radio value="time_expired_error" className="!flex !items-start">
                <div className="ml-2">
                  <div className="font-medium">Czas minął/błąd aplikacji</div>
                  <div className="text-xs text-gray-500 mt-1">
                    Komunikat o błędzie sieci i prośba o ponowną próbę weryfikacji
                  </div>
                </div>
              </Radio>
              <Radio value="custom" className="!flex !items-start">
                <div className="ml-2">
                  <div className="font-medium">Własne uzasadnienie</div>
                  <div className="text-xs text-gray-500 mt-1">Treść zostanie bezpośrednio pokazana użytkownikowi</div>
                </div>
              </Radio>
            </div>
          </Radio.Group>
        </div>

        {rejectionModal.reason === 'custom' && (
          <div>
            <Text strong className="block mb-2">
              Wpisz uzasadnienie:
            </Text>
            <TextArea
              value={rejectionModal.customMessage}
              onChange={(e) => setRejectionModal({ ...rejectionModal, customMessage: e.target.value })}
              placeholder="Wpisz powód odrzucenia weryfikacji..."
              rows={4}
              maxLength={500}
              showCount
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
